import QueueableRequest from './QueueableRequest';
import { FAQ_TOPIC_ENDPOINT } from '../../config/api';
import { bindParamsToRoute } from '../../helpers/url';

export default class FaqTopicRequest extends QueueableRequest {
  constructor(topic) {
    super(bindParamsToRoute(FAQ_TOPIC_ENDPOINT, { topic }));
  }
}
